(() => {
  const V = window.VERAE || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover)');

  // Sizes come in whatever order they were created (S, M, L, XS). Show them small to large.
  const SIZE_ORDER = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL'];
  const sizeRank = (value) => {
    const i = SIZE_ORDER.indexOf(String(value || '').trim().toUpperCase());
    return i === -1 ? 999 : i;
  };
  const bySize = (getValue) => (a, b) => sizeRank(getValue(a)) - sizeRank(getValue(b));
  const sortSizeOptions = (root = document) => {
    $$('.option__values', root).forEach((wrap) => {
      const inputs = $$('input', wrap);
      if (inputs.length < 2 || !$('.size-btn', wrap)) return;
      if (inputs.some((input) => sizeRank(input.value) === 999)) return;
      inputs
        .map((input) => ({ input, label: wrap.querySelector(`label[for="${CSS.escape(input.id)}"]`) }))
        .sort(bySize((pair) => pair.input.value))
        .forEach(({ input, label }) => { wrap.appendChild(input); if (label) wrap.appendChild(label); });
    });
    $$('.card__sizes, [data-size-sort]', root).forEach((wrap) => {
      const items = Array.from(wrap.children);
      if (items.length < 2 || items.some((el) => sizeRank(el.textContent) === 999)) return;
      items.sort(bySize((el) => el.textContent)).forEach((el) => wrap.appendChild(el));
    });
    $$('select[data-size-select]', root).forEach((select) => {
      const options = Array.from(select.options);
      const label = (o) => o.textContent.split('·')[0];
      if (options.length < 2 || options.some((o) => sizeRank(label(o)) === 999)) return;
      const value = select.value;
      options.sort(bySize(label)).forEach((o) => select.appendChild(o));
      select.value = value;
    });
  };
  V.sortSizeOptions = sortSizeOptions;

  // Big uppercase headings in a wide typeface can have a single word wider than the screen
  // ("TRANSPARENCIAS."). Shrink the heading just enough for its longest word to fit.
  const fitTargets = new Set();
  const fitText = (el) => {
    if (!el.isConnected) return;
    el.style.fontSize = '';
    const available = el.clientWidth;
    if (!available) return;
    const base = parseFloat(window.getComputedStyle(el).fontSize);
    const probe = document.createElement('fit-probe');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:0;top:0;pointer-events:none;';
    el.appendChild(probe);
    let widest = 0;
    el.textContent.replace(/\s+/g, ' ').trim().split(' ').forEach((word) => {
      if (!word) return;
      probe.textContent = word;
      widest = Math.max(widest, probe.getBoundingClientRect().width);
    });
    probe.remove();
    if (widest > available) el.style.fontSize = `${Math.floor((base * available) / widest * 0.985 * 10) / 10}px`;
  };
  const fitObserver = 'ResizeObserver' in window
    ? new ResizeObserver((entries) => entries.forEach((entry) => {
        const el = entry.target;
        const width = Math.round(entry.contentRect.width);
        if (el._fitWidth === width) return;
        el._fitWidth = width;
        fitText(el);
      }))
    : null;
  const initFit = (root = document) => {
    $$('[data-fit], .display, .h1, .product__title', root).forEach((el) => {
      if (fitTargets.has(el)) return;
      fitTargets.add(el);
      fitText(el);
      if (fitObserver) fitObserver.observe(el);
    });
  };
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => fitTargets.forEach((el) => fitText(el)));
  }

  const debounce = (fn, wait = 200) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const formatMoney = (cents) => {
    const value = (Number(cents) || 0) / 100;
    const fixed = value.toFixed(2);
    const [int, dec] = fixed.split('.');
    const intDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const comma = `${intDots},${dec}`;
    if (V.priceSuffix) return `${comma} €`;
    const format = V.moneyFormat || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, int.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, `${int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${dec}`);
  };
  V.formatMoney = formatMoney;

  const toast = (message) => {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => { el.hidden = true; }, 300);
    }, 3200);
  };

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  // Opening a modal moves focus into a panel that is still off-screen (it slides in).
  // Browsers then scroll whatever they can to reach it: the dialog itself, or the whole page on iOS.
  // Closing returns focus to the opener, which can scroll the page again. We pin the page where it was.
  const keepScroll = (y) => {
    if (Math.abs(window.scrollY - y) > 1) window.scrollTo({ top: y, left: 0, behavior: 'instant' });
  };
  const resetDialogScroll = (dialog) => {
    dialog.scrollTop = 0;
    dialog.scrollLeft = 0;
  };

  const openDialog = (dialog, opener) => {
    if (!dialog || dialog.open) return;
    const y = window.scrollY;
    dialog._opener = opener || document.activeElement;
    dialog._scrollY = y;
    document.documentElement.classList.add('is-locked');
    dialog.showModal();
    resetDialogScroll(dialog);
    keepScroll(y);
    requestAnimationFrame(() => {
      resetDialogScroll(dialog);
      keepScroll(y);
      requestAnimationFrame(() => dialog.classList.add('is-open'));
    });
  };

  const closeDialog = (dialog) => {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-open');
    const done = () => {
      if (!dialog.open) return;
      const y = typeof dialog._scrollY === 'number' ? dialog._scrollY : window.scrollY;
      dialog.close();
      if (!$$('dialog[open]').length) document.documentElement.classList.remove('is-locked');
      if (dialog._opener && document.contains(dialog._opener)) dialog._opener.focus({ preventScroll: true });
      keepScroll(y);
      requestAnimationFrame(() => keepScroll(y));
    };
    const panel = $('.drawer__panel', dialog);
    if (panel && !reduceMotion) {
      panel.addEventListener('transitionend', done, { once: true });
      setTimeout(() => { if (dialog.open) done(); }, 420);
    } else {
      done();
    }
  };
  V.openDialog = openDialog;
  V.closeDialog = closeDialog;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.open);
      if (dialog) {
        event.preventDefault();
        openDialog(dialog, opener);
        dialog.dispatchEvent(new CustomEvent('dialog:open', { detail: { opener } }));
      }
      return;
    }
    const closer = event.target.closest('[data-close]');
    if (closer) {
      event.preventDefault();
      closeDialog(closer.closest('dialog'));
      return;
    }
    if (event.target.matches('dialog[open]')) closeDialog(event.target);
  });

  document.addEventListener('cancel', (event) => {
    if (event.target.matches('dialog')) {
      event.preventDefault();
      closeDialog(event.target);
    }
  }, true);

  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = $$('.announcement__item', this);
      if (this.items.length < 2 || reduceMotion) return;
      this.index = 0;
      this.timer = setInterval(() => this.next(), Number(this.dataset.speed || 5) * 1000);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }
    next() {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.wrap = this.closest('.header-wrap') || this;
      this.root = document.documentElement;
      this.overlay = document.body.classList.contains('header-overlay');
      this.lastY = window.scrollY;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.ticking = false; this.onScroll(); });
      }, { passive: true });
      const setHeight = () => this.root.style.setProperty('--header-h', `${this.wrap.offsetHeight}px`);
      setHeight();
      if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(this.wrap);
      this.onScroll();
    }
    setHidden(hidden) {
      if (this.wrap.classList.contains('is-hidden') === hidden) return;
      this.wrap.classList.toggle('is-hidden', hidden);
      this.root.classList.toggle('header-hidden', hidden);
    }
    onScroll() {
      if (this.root.classList.contains('is-locked')) return;
      const y = Math.max(0, window.scrollY);
      const h = this.wrap.offsetHeight;
      if (this.overlay) this.wrap.classList.toggle('is-solid', y > 24);
      this.wrap.classList.toggle('is-scrolled', y > 4);
      if (canHover.matches && this.wrap.matches(':hover')) { this.lastY = y; return; }
      if (y > h * 3 && y > this.lastY + 6) this.setHidden(true);
      else if (y < this.lastY - 6 || y < h * 2) this.setHidden(false);
      this.lastY = y;
    }
  }
  customElements.define('site-header', SiteHeader);

  class HeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = $('video', this);
      this.button = $('.hero__pause', this);
      if (!this.video) return;
      this.video.muted = true;
      if (reduceMotion) this.video.pause();
      const play = () => this.video.play().catch(() => {});
      if (!reduceMotion) play();
      if (this.button) {
        this.button.setAttribute('aria-pressed', reduceMotion ? 'true' : 'false');
        this.button.addEventListener('click', () => {
          if (this.video.paused) { play(); this.button.setAttribute('aria-pressed', 'false'); }
          else { this.video.pause(); this.button.setAttribute('aria-pressed', 'true'); }
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          if (this.button && this.button.getAttribute('aria-pressed') === 'true') return;
          entry.isIntersecting ? play() : this.video.pause();
        }).observe(this);
      }
    }
  }
  customElements.define('hero-video', HeroVideo);

  const revealObserver = 'IntersectionObserver' in window && !reduceMotion
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  const initReveal = (root = document) => {
    $$('.reveal:not(.is-in)', root).forEach((el) => {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  };

  class RailScroller extends HTMLElement {
    connectedCallback() {
      this.track = $('.rail', this);
      if (!this.track || this._ready) return;
      this._ready = true;
      this.prev = $('[data-rail-prev]', this);
      this.next = $('[data-rail-next]', this);
      const step = () => this.track.clientWidth * 0.9;
      if (this.prev) this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (this.next) this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));

      this.progress = document.createElement('div');
      this.progress.className = 'rail-progress';
      this.progress.setAttribute('aria-hidden', 'true');
      this.progress.innerHTML = '<span></span>';
      this.track.after(this.progress);
      const bar = this.progress.firstElementChild;

      let frame;
      this.update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const max = Math.max(0, scrollWidth - clientWidth);
          const visible = scrollWidth ? Math.min(1, clientWidth / scrollWidth) : 1;
          const ratio = max ? Math.min(1, Math.max(0, scrollLeft / max)) : 0;
          this.progress.hidden = max < 4;
          bar.style.width = `${visible * 100}%`;
          bar.style.transform = `translateX(${(ratio * (1 - visible) / visible) * 100}%)`;
          if (this.prev) this.prev.disabled = scrollLeft <= 2;
          if (this.next) this.next.disabled = scrollLeft >= max - 2;
        });
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(this.update).observe(this.track);
      else window.addEventListener('resize', debounce(this.update, 120));
      this.update();
    }
  }
  customElements.define('rail-scroller', RailScroller);

  const Cart = {
    sectionIds() {
      const ids = [];
      if (document.getElementById('shopify-section-cart-drawer')) ids.push('cart-drawer');
      const main = $('[data-main-cart]');
      if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
      if (!ids.length) ids.push('cart-drawer');
      return ids;
    },
    async request(url, body) {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: this.sectionIds().join(','), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        const message = data.description || data.message || V.strings.cartError;
        throw new Error(typeof message === 'string' ? message : V.strings.cartError);
      }
      return data;
    },
    async add(items) {
      const data = await this.request(`${V.routes.cartAdd}.js`, { items });
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'add', items } }));
      return data;
    },
    async change(key, quantity) {
      const data = await this.request(`${V.routes.cartChange}.js`, { id: key, quantity });
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { action: 'change', cart: data } }));
      return data;
    },
    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = parseHTML(html);
        const fresh = doc.getElementById(`shopify-section-${id}`) || doc.body.firstElementChild;
        const current = document.getElementById(`shopify-section-${id}`);
        if (!fresh || !current) return;
        if (id === 'cart-drawer') {
          const freshBody = $('[data-drawer-content]', fresh);
          const currentBody = $('[data-drawer-content]', current);
          if (freshBody && currentBody) currentBody.replaceWith(freshBody);
          const count = $('[data-cart-root]', fresh)?.dataset.count;
          if (count !== undefined) this.setCount(count);
        } else {
          current.innerHTML = fresh.innerHTML;
          const count = $('[data-cart-root]', fresh)?.dataset.count;
          if (count !== undefined) this.setCount(count);
        }
      });
      initReveal();
      document.dispatchEvent(new CustomEvent('cart:rendered'));
    },
    setCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        const grew = Number(count) > Number(el.dataset.count || 0);
        el.textContent = Number(count) > 0 ? count : '';
        el.dataset.count = count;
        if (grew && !reduceMotion) {
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
          el.addEventListener('animationend', () => el.classList.remove('is-bump'), { once: true });
        }
      });
    },
    open() {
      const drawer = $('#CartDrawer');
      if (drawer && V.cartType === 'drawer') {
        openDialog(drawer);
        drawer.dispatchEvent(new CustomEvent('dialog:open'));
      } else {
        window.location.href = V.routes.cart;
      }
    }
  };
  V.Cart = Cart;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-qty-change]');
    if (!button) return;
    event.preventDefault();
    const line = button.closest('[data-line-key]');
    if (!line) return;
    const input = $('input[data-qty]', line);
    const current = Number(input?.value || line.dataset.quantity || 0);
    const next = button.dataset.qtyChange === 'remove' ? 0 : Math.max(0, current + Number(button.dataset.qtyChange));
    line.classList.add('is-updating');
    try { await Cart.change(line.dataset.lineKey, next); }
    catch (error) { toast(error.message); line.classList.remove('is-updating'); }
  });

  document.addEventListener('change', async (event) => {
    const input = event.target.closest('input[data-qty]');
    if (!input) return;
    const line = input.closest('[data-line-key]');
    line.classList.add('is-updating');
    try { await Cart.change(line.dataset.lineKey, Math.max(0, Number(input.value) || 0)); }
    catch (error) { toast(error.message); line.classList.remove('is-updating'); }
  });

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.closest('dialog');
      if (!this.dialog || this.dialog._bound) return;
      this.dialog._bound = true;
      this.dialog.addEventListener('dialog:open', () => this.loadUpsell());
      document.addEventListener('cart:rendered', () => { if (this.dialog.open) this.loadUpsell(true); });
    }
    async loadUpsell(force) {
      const slot = $('[data-cart-upsell]', this.dialog);
      if (!slot || !slot.dataset.productId) return;
      if (slot.dataset.loaded === slot.dataset.productId && !force) return;
      try {
        const url = `${V.routes.recommendations}?product_id=${slot.dataset.productId}&limit=6&intent=related&section_id=cart-recommendations`;
        const html = await fetch(url).then((r) => r.text());
        const doc = parseHTML(html);
        const inner = $('[data-recs]', doc);
        const exclude = (slot.dataset.exclude || '').split(',');
        if (inner) {
          $$('[data-product-id]', inner).forEach((el) => { if (exclude.includes(el.dataset.productId)) el.remove(); });
          if ($$('[data-product-id]', inner).length) {
            slot.innerHTML = inner.outerHTML;
            slot.hidden = false;
          } else {
            slot.hidden = true;
          }
        }
        slot.dataset.loaded = slot.dataset.productId;
      } catch (e) {
        slot.hidden = true;
      }
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add-variant]');
    if (!button) return;
    event.preventDefault();
    const holder = button.closest('[data-quick-holder]');
    const select = holder ? $('select[data-quick-select]', holder) : null;
    const id = select ? select.value : button.dataset.quickAddVariant;
    if (!id) return;
    button.classList.add('is-loading');
    button.disabled = true;
    try {
      await Cart.add([{ id: Number(id), quantity: 1 }]);
      if (V.cartType === 'drawer' && $('#CartDrawer')?.open) toast(V.strings.added);
      else Cart.open();
    } catch (error) {
      toast(error.message);
    } finally {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  });

  class ProductCard extends HTMLElement {
    connectedCallback() {
      const json = $('script[type="application/json"]', this);
      if (!json) return;
      try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
      this.image = $('.card__img-main', this);
      this.alt = $('.card__img-alt', this);
      this.links = $$('a[data-card-link]', this);
      this.sizesWrap = $('.card__sizes', this);
      this.colorLabel = $('[data-card-color]', this);
      this.color = this.dataset.color || (this.data.colors[0] && this.data.colors[0].name);
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-swatch]');
        if (swatch) {
          event.preventDefault();
          this.setColor(swatch.dataset.swatch);
          return;
        }
        const size = event.target.closest('[data-size-variant]');
        if (size) {
          event.preventDefault();
          this.addSize(size);
          return;
        }
        const toggle = event.target.closest('.card__quick-toggle');
        if (toggle) {
          event.preventDefault();
          $$('product-card.is-quick-open').forEach((c) => { if (c !== this) c.classList.remove('is-quick-open'); });
          this.classList.toggle('is-quick-open');
        }
      });
      $$('[data-swatch]', this).forEach((el) => {
        el.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) this.setColor(el.dataset.swatch, true); });
      });
    }
    setColor(name, preview) {
      const color = this.data.colors.find((c) => c.name === name);
      if (!color) return;
      this.color = name;
      $$('[data-swatch]', this).forEach((el) => el.classList.toggle('is-active', el.dataset.swatch === name));
      if (color.image && this.image) {
        this.image.src = color.image;
        this.image.srcset = color.srcset || '';
      }
      if (this.alt && color.image) this.alt.style.visibility = preview ? 'hidden' : '';
      if (color.url) this.links.forEach((a) => { a.href = color.url; });
      if (this.colorLabel) this.colorLabel.textContent = name;
      this.renderSizes(color);
    }
    renderSizes(color) {
      if (!this.sizesWrap || !color.sizes) return;
      const sizes = color.sizes.every((s) => sizeRank(s.name) !== 999) ? [...color.sizes].sort(bySize((s) => s.name)) : color.sizes;
      this.sizesWrap.innerHTML = sizes.map((s) => `<button type="button" data-size-variant="${s.id}" ${s.available ? '' : 'disabled'} aria-label="${s.name}">${s.name}</button>`).join('');
    }
    async addSize(button) {
      if (button.disabled) return;
      button.classList.add('is-loading');
      try {
        await Cart.add([{ id: Number(button.dataset.sizeVariant), quantity: 1 }]);
        this.classList.remove('is-quick-open');
        Cart.open();
      } catch (error) {
        toast(error.message);
      } finally {
        button.classList.remove('is-loading');
      }
    }
  }
  customElements.define('product-card', ProductCard);

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const json = $('script[data-product-json]', this);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = $('form[data-product-form]', this);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      this.submit = this.form ? $('[data-add-button]', this.form) : null;
      this.priceEl = $('[data-price]', this);
      this.stockEl = $('[data-stock]', this);
      this.errorEl = $('[data-form-error]', this);
      this.gallery = document.querySelector(`media-gallery[data-section="${this.dataset.section}"]`);
      this.sticky = document.querySelector(`sticky-buy[data-section="${this.dataset.section}"]`);
      this.sizeIndexes = this.product.options.map((name, i) => (/talla|size|tama/i.test(name) ? i : -1)).filter((i) => i > -1);
      this.colorIndex = this.product.options.findIndex((name) => /color|colour/i.test(name));
      this.selected = this.readSelection();
      this.explicit = new URLSearchParams(window.location.search).has('variant');
      if (!this.explicit && this.sizeIndexes.length) {
        this.sizeIndexes.forEach((i) => {
          this.selected[i] = null;
          $$(`input[data-option-index="${i}"]`, this).forEach((input) => { input.checked = false; });
        });
      }
      this.addEventListener('change', (event) => {
        const input = event.target.closest('input[data-option-index]');
        if (!input) return;
        this.selected[Number(input.dataset.optionIndex)] = input.value;
        this.explicit = true;
        this.update();
      });
      if (this.form) this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.update(true);
    }
    readSelection() {
      return this.product.options.map((_, i) => {
        const checked = $(`input[data-option-index="${i}"]:checked`, this);
        return checked ? checked.value : null;
      });
    }
    findVariant(selection) {
      return this.product.variants.find((v) => v.options.every((o, i) => selection[i] === null || selection[i] === o));
    }
    exactVariant() {
      if (this.selected.some((s) => s === null)) return null;
      return this.product.variants.find((v) => v.options.every((o, i) => this.selected[i] === o)) || null;
    }
    missingSize() {
      return this.sizeIndexes.some((i) => this.selected[i] === null);
    }
    update(initial) {
      const variant = this.exactVariant();
      const preview = variant || this.findVariant(this.selected) || this.product.variants[0];
      this.markAvailability();
      this.product.options.forEach((_, i) => {
        const label = $(`[data-option-value="${i}"]`, this);
        if (label) label.textContent = this.selected[i] || '';
      });
      if (variant && this.idInput) this.idInput.value = variant.id;
      this.renderPrice(preview);
      this.renderButton(variant);
      this.renderStock(variant, preview);
      this.form?.classList.toggle('needs-size', this.missingSize());
      if (this.errorEl) this.errorEl.hidden = true;
      if (!initial && variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      const color = this.colorIndex > -1 ? this.selected[this.colorIndex] : null;
      if (this.gallery) this.gallery.showVariant(preview, initial);
      if (this.sticky) this.sticky.render({ variant, preview, color, missingSize: this.missingSize(), product: this.product });
      const size = this.sizeIndexes.length ? this.selected[this.sizeIndexes[0]] : null;
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant, preview, color, size } }));
    }
    markAvailability() {
      this.product.options.forEach((_, i) => {
        $$(`input[data-option-index="${i}"]`, this).forEach((input) => {
          const candidates = this.product.variants.filter((v) => v.options.every((o, j) => {
            if (j === i) return o === input.value;
            if (this.selected[j] === null) return true;
            if (i === this.colorIndex && this.sizeIndexes.includes(j)) return true;
            return o === this.selected[j];
          }));
          const available = candidates.some((v) => v.available);
          const exists = candidates.length > 0;
          const label = input.nextElementSibling;
          if (label) {
            label.classList.toggle('is-unavailable', !available);
            label.classList.toggle('is-missing', !exists);
          }
          input.dataset.available = available ? 'true' : 'false';
        });
      });
    }
    renderPrice(variant) {
      if (!this.priceEl || !variant) return;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      const save = onSale ? V.strings.save.replace('[amount]', formatMoney(variant.compare_at_price - variant.price)) : '';
      this.priceEl.classList.toggle('price--sale', !!onSale);
      this.priceEl.innerHTML = `<span class="price__now">${formatMoney(variant.price)}</span>${onSale ? `<s>${formatMoney(variant.compare_at_price)}</s><span class="price__save">${save}</span>` : ''}`;
    }
    renderButton(variant) {
      if (!this.submit) return;
      const label = $('[data-add-label]', this.submit) || this.submit;
      if (this.missingSize()) {
        label.textContent = V.strings.chooseSize;
        this.submit.removeAttribute('disabled');
        this.submit.dataset.state = 'choose';
      } else if (!variant) {
        label.textContent = V.strings.unavailable;
        this.submit.setAttribute('disabled', '');
        this.submit.dataset.state = 'unavailable';
      } else if (!variant.available) {
        label.textContent = V.strings.soldOut;
        this.submit.setAttribute('disabled', '');
        this.submit.dataset.state = 'soldout';
      } else {
        label.textContent = `${V.strings.addToCart} · ${formatMoney(variant.price)}`;
        this.submit.removeAttribute('disabled');
        this.submit.dataset.state = 'add';
      }
    }
    renderStock(variant, preview) {
      if (!this.stockEl) return;
      const threshold = Number(this.dataset.lowStock || 0);
      const el = this.stockEl;
      el.classList.remove('is-low', 'is-out');
      if (!variant) {
        const color = this.colorIndex > -1 ? this.selected[this.colorIndex] : null;
        const pool = this.product.variants.filter((v) => !color || v.options[this.colorIndex] === color);
        const available = pool.filter((v) => v.available);
        if (!available.length) { el.classList.add('is-out'); el.textContent = V.strings.soldOut; }
        else { el.textContent = V.strings.inStock; }
        return;
      }
      if (!variant.available) { el.classList.add('is-out'); el.textContent = V.strings.soldOut; return; }
      const sizeName = this.sizeIndexes.length ? variant.options[this.sizeIndexes[0]] : '';
      if (threshold > 0 && variant.tracked && variant.qty > 0 && variant.qty <= threshold) {
        el.classList.add('is-low');
        el.innerHTML = (sizeName ? V.strings.lowStock : V.strings.lowStockPlain).replace('[count]', variant.qty).replace('[size]', sizeName);
      } else {
        el.textContent = V.strings.inStock;
      }
    }
    async onSubmit(event) {
      event.preventDefault();
      if (this.missingSize()) {
        const fieldset = $(`fieldset[data-option-fieldset="${this.sizeIndexes.find((i) => this.selected[i] === null)}"]`, this);
        if (fieldset) {
          fieldset.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          fieldset.animate?.([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
          $('input', fieldset)?.focus({ preventScroll: true });
        }
        return;
      }
      const variant = this.exactVariant();
      if (!variant || !variant.available) return;
      this.submit.classList.add('is-loading');
      const qtyInput = $('input[name="quantity"]', this.form);
      try {
        await Cart.add([{ id: variant.id, quantity: Number(qtyInput?.value || 1) }]);
        Cart.open();
      } catch (error) {
        if (this.errorEl) { this.errorEl.textContent = error.message; this.errorEl.hidden = false; }
        else toast(error.message);
      } finally {
        this.submit.classList.remove('is-loading');
      }
    }
    selectValue(index, value) {
      const input = $$(`input[data-option-index="${index}"]`, this).find((el) => el.value === value);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    triggerSubmit() {
      this.form?.requestSubmit ? this.form.requestSubmit() : this.form?.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }
  customElements.define('product-info', ProductInfo);

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('.gallery__track', this);
      this.counter = $('[data-counter]', this);
      this.dots = $('.gallery__dots', this);
      if (!this.track) return;
      this.track.addEventListener('scroll', debounce(() => this.syncIndex(), 40), { passive: true });
      this.addEventListener('click', (event) => {
        const zoom = event.target.closest('.gallery__zoom');
        if (zoom) this.openLightbox(zoom.closest('.gallery__item'));
      });
      this.refresh();
    }
    visible() { return $$('.gallery__item:not(.is-hidden)', this.track); }
    refresh() {
      const items = this.visible();
      items.forEach((el, i) => el.classList.toggle('is-first', i === 0));
      if (this.dots) this.dots.innerHTML = items.length > 1 ? items.map((_, i) => `<span class="${i === 0 ? 'is-active' : ''}"></span>`).join('') : '';
      this.syncIndex();
    }
    syncIndex() {
      const items = this.visible();
      if (!items.length) return;
      const index = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      const safe = Math.min(Math.max(index, 0), items.length - 1);
      if (this.counter) this.counter.textContent = `${safe + 1} / ${items.length}`;
      if (this.dots) $$('span', this.dots).forEach((d, i) => d.classList.toggle('is-active', i === safe));
    }
    showVariant(variant, initial) {
      if (!variant || !variant.media_id) return;
      const target = $(`.gallery__item[data-media-id="${variant.media_id}"]`, this.track);
      if (!target) return;
      $$('.gallery__item[data-variant-media]', this.track).forEach((el) => el.classList.toggle('is-hidden', el !== target));
      target.classList.remove('is-hidden');
      if (this.track.firstElementChild !== target) this.track.prepend(target);
      this.refresh();
      if (!initial) this.track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    openLightbox(start) {
      const dialog = $('dialog.lightbox', this);
      if (!dialog) return;
      const track = $('.lightbox__track', dialog);
      const items = this.visible();
      track.innerHTML = items.map((el) => {
        const img = $('img', el);
        if (!img) return '';
        const full = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000');
        return `<div><img src="${full}" alt="${img.alt || ''}" loading="lazy"></div>`;
      }).join('');
      openDialog(dialog);
      const index = Math.max(0, items.indexOf(start));
      requestAnimationFrame(() => { track.scrollLeft = index * track.clientWidth; });
    }
  }
  customElements.define('media-gallery', MediaGallery);

  class StickyBuy extends HTMLElement {
    connectedCallback() {
      this.info = document.querySelector(`product-info[data-section="${this.dataset.section}"]`);
      const anchor = this.info ? $('[data-add-button]', this.info) : null;
      this.button = $('button', this);
      this.variantEl = $('[data-sticky-variant]', this);
      this.priceEl = $('[data-sticky-price]', this);
      if (!anchor || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entry]) => {
        const below = entry.boundingClientRect.top < 0;
        const visible = !entry.isIntersecting && below;
        this.classList.toggle('is-visible', visible);
        document.documentElement.classList.toggle('sticky-buy-on', visible);
      }).observe(anchor);
      this.button.addEventListener('click', () => this.info.triggerSubmit());
    }
    render({ variant, preview, color, missingSize }) {
      if (!this.button) return;
      if (this.priceEl && preview) this.priceEl.textContent = formatMoney(preview.price);
      if (this.variantEl) this.variantEl.textContent = variant ? variant.title : (color || '');
      if (missingSize) { this.button.textContent = V.strings.chooseSize; this.button.disabled = false; }
      else if (!variant || !variant.available) { this.button.textContent = variant ? V.strings.soldOut : V.strings.unavailable; this.button.disabled = true; }
      else { this.button.textContent = V.strings.addToCart; this.button.disabled = false; }
    }
  }
  customElements.define('sticky-buy', StickyBuy);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if ($('[data-recs-content]', this) || !this.dataset.url) return;
      const load = async () => {
        try {
          const html = await fetch(this.dataset.url).then((r) => r.text());
          const doc = parseHTML(html);
          const fresh = $('product-recommendations', doc);
          if (fresh && $('[data-recs-content]', fresh)) {
            this.innerHTML = fresh.innerHTML;
            initReveal(this);
          } else {
            this.hidden = true;
          }
        } catch (e) {
          this.hidden = true;
        }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(this);
      } else {
        load();
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  class CompleteSet extends HTMLElement {
    connectedCallback() {
      this.items = $$('[data-complete-item]', this);
      if (!this.items.length) { this.hidden = true; return; }
      const info = document.querySelector(`product-info[data-section="${this.dataset.section}"]`);
      if (info) info.addEventListener('variant:change', (e) => { this.size = e.detail.size || null; this.applyColor(e.detail.color); });
      this.applyColor(this.dataset.color);
    }
    applyColor(color) {
      const norm = (s) => (s || '').toString().trim().toLowerCase();
      let shown = 0;
      this.items.forEach((item) => {
        const data = JSON.parse($('script', item).textContent);
        let pool = data.variants;
        if (color && data.color_index > -1) {
          pool = data.variants.filter((v) => norm(v.options[data.color_index]) === norm(color));
        }
        const sizeOf = (v) => (data.size_index > -1 ? v.options[data.size_index] : v.title);
        if (data.size_index > -1 && pool.every((v) => sizeRank(sizeOf(v)) !== 999)) pool = [...pool].sort(bySize(sizeOf));
        const available = pool.filter((v) => v.available);
        if (!available.length || shown >= 3) { item.hidden = true; return; }
        item.hidden = false;
        shown += 1;
        const img = $('img', item);
        const preferred = this.size ? [this.size] : ['S', 'M', 'L', 'XS', 'XL'];
        const first = preferred.map((p) => available.find((v) => norm(sizeOf(v)) === norm(p))).find(Boolean) || available[0];
        if (img && first.image) { img.src = first.image; img.srcset = ''; }
        const link = $('a', item);
        if (link) link.href = `${data.url}?variant=${first.id}`;
        const select = $('select', item);
        if (select) {
          select.innerHTML = pool.map((v) => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${data.size_index > -1 ? v.options[data.size_index] : v.title}${v.available ? '' : ` · ${V.strings.soldOut}`}</option>`).join('');
          select.value = String(first.id);
        }
        const price = $('[data-complete-price]', item);
        if (price) price.textContent = formatMoney(first.price);
      });
      this.hidden = shown === 0;
    }
  }
  customElements.define('complete-set', CompleteSet);

  class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.chart = JSON.parse($('script[data-size-chart]', this).textContent);
      this.dialog = this.closest('dialog');
      this.result = $('[data-finder-result]', this);
      this.applyBtn = $('[data-finder-apply]', this);
      this.tabs = $$('[role="tab"]', this);
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.setTab(tab.dataset.tab)));
      $$('input[data-measure]', this).forEach((input) => input.addEventListener('input', debounce(() => this.compute(), 150)));
      if (this.dialog) this.dialog.addEventListener('dialog:open', (e) => {
        const kind = e.detail?.opener?.dataset.guideKind;
        if (kind) this.setTab(kind);
      });
      if (this.applyBtn) this.applyBtn.addEventListener('click', () => this.apply());
      this.setTab(this.dataset.kind || 'bottom');
    }
    setTab(kind) {
      this.kind = kind;
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tab === kind)));
      $$('[data-measure-field]', this).forEach((field) => {
        const kinds = field.dataset.measureField.split(',');
        field.hidden = !kinds.includes(kind);
      });
      this.compute();
    }
    compute() {
      const keys = this.kind === 'top' ? ['chest', 'waist'] : this.kind === 'set' ? ['chest', 'waist', 'hip'] : ['waist', 'hip'];
      const values = keys.map((k) => parseFloat(($(`input[data-measure="${k}"]`, this)?.value || '').replace(',', '.')));
      $$('.size-table tr', this).forEach((tr) => tr.classList.remove('is-match'));
      this.match = null;
      if (this.applyBtn) this.applyBtn.hidden = true;
      if (values.some((v) => !Number.isFinite(v) || v <= 0)) { this.result.textContent = this.result.dataset.empty; return; }
      const indexes = keys.map((k, n) => {
        const col = this.chart.map((row) => row[k]);
        if (values[n] < col[0] - 4 || values[n] > col[col.length - 1] + 4) return -1;
        let best = 0;
        col.forEach((ref, i) => { if (Math.abs(values[n] - ref) < Math.abs(values[n] - col[best])) best = i; });
        return best;
      });
      if (indexes.includes(-1)) { this.result.textContent = this.result.dataset.outside; return; }
      const max = Math.max(...indexes);
      const min = Math.min(...indexes);
      const row = this.chart[this.kind === 'bottom' ? min : max];
      this.match = row.size;
      $$(`.size-table tr[data-size="${row.size}"]`, this).forEach((tr) => tr.classList.add('is-match'));
      const between = max !== min;
      this.result.innerHTML = `<strong>${row.size}</strong>${between ? this.result.dataset.between : this.result.dataset.match}`;
      const info = $('product-info');
      if (info && this.applyBtn) {
        const index = info.sizeIndexes?.[0];
        const exists = index !== undefined && $$(`input[data-option-index="${index}"]`, info).some((el) => el.value === row.size);
        this.applyBtn.hidden = !exists;
        this.applyBtn.textContent = this.applyBtn.dataset.label.replace('[size]', row.size);
      }
    }
    apply() {
      const info = $('product-info');
      if (!info || !this.match) return;
      info.sizeIndexes.forEach((i) => info.selectValue(i, this.match));
      closeDialog(this.dialog);
    }
  }
  customElements.define('size-guide', SizeGuide);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = $('input[type="search"]', this);
      this.results = $('[data-predictive-results]', this);
      this.defaults = this.results ? this.results.innerHTML : '';
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', debounce(() => this.search(), 220));
      const dialog = this.closest('dialog');
      if (dialog) dialog.addEventListener('dialog:open', () => setTimeout(() => this.input.focus(), 60));
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = this.defaults; return; }
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        const url = `${V.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const html = await fetch(url, { signal: this.controller.signal }).then((r) => r.text());
        const doc = parseHTML(html);
        const fresh = $('[data-predictive-content]', doc);
        this.results.innerHTML = fresh ? fresh.innerHTML : '';
      } catch (e) {
        if (e.name !== 'AbortError') this.results.innerHTML = this.defaults;
      }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.onChange = debounce(() => this.apply(), 350);
      this.addEventListener('change', (event) => {
        if (event.target.closest('form[data-filter-form], select[data-sort]')) this.onChange();
      });
      this.addEventListener('submit', (event) => {
        if (event.target.matches('form[data-filter-form]')) { event.preventDefault(); this.apply(); }
      });
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-filter-link]');
        if (link) { event.preventDefault(); this.load(new URL(link.href, window.location.origin)); }
        const more = event.target.closest('[data-load-more]');
        if (more) { event.preventDefault(); this.loadMore(more); }
      });
      window.addEventListener('popstate', () => this.load(new URL(window.location.href), true));
    }
    params() {
      const form = $('form[data-filter-form]', document);
      const data = form ? new FormData(form) : new FormData();
      const sort = $('select[data-sort]', this);
      if (sort) data.set('sort_by', sort.value);
      const params = new URLSearchParams();
      for (const [k, v] of data.entries()) { if (v !== '') params.append(k, v); }
      const q = new URLSearchParams(window.location.search).get('q');
      if (q && !params.has('q')) params.set('q', q);
      return params;
    }
    apply() {
      const url = new URL(window.location.pathname, window.location.origin);
      url.search = this.params().toString();
      this.load(url);
    }
    async load(url, fromPop) {
      const grid = $('[data-collection-grid]', this);
      grid?.classList.add('is-loading');
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      try {
        const html = await fetch(fetchUrl).then((r) => r.text());
        const doc = parseHTML(html);
        ['[data-collection-grid]', '[data-active-filters]', '[data-results-count]', '[data-load-more-wrap]'].forEach((sel) => {
          const fresh = $(sel, doc);
          const current = $(sel, this);
          if (fresh && current) current.replaceWith(fresh);
        });
        const freshForm = $('form[data-filter-form]', doc);
        const currentForm = $('form[data-filter-form]', document);
        if (freshForm && currentForm) {
          const open = $$('details[open]', currentForm).map((d) => d.dataset.filter);
          currentForm.innerHTML = freshForm.innerHTML;
          open.forEach((key) => { const d = $(`details[data-filter="${key}"]`, currentForm); if (d) d.open = true; });
        }
        const freshCount = $('[data-filter-count]', doc);
        $$('[data-filter-count]').forEach((el) => { el.textContent = freshCount ? freshCount.textContent : ''; });
        const freshTotal = $('[data-results-total]', doc);
        if (freshTotal) $$('[data-results-total]').forEach((el) => { el.textContent = freshTotal.textContent; });
        if (!fromPop) window.history.pushState({}, '', url.pathname + url.search);
        initReveal(this);
      } catch (e) {
        window.location.href = url.toString();
      }
    }
    async loadMore(button) {
      const url = new URL(button.dataset.loadMore, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);
      button.classList.add('is-loading');
      try {
        const html = await fetch(url).then((r) => r.text());
        const doc = parseHTML(html);
        const grid = $('[data-collection-grid]', this);
        $$('[data-collection-grid] > *', doc).forEach((el) => grid.appendChild(el));
        const wrap = $('[data-load-more-wrap]', this);
        const fresh = $('[data-load-more-wrap]', doc);
        if (wrap && fresh) wrap.replaceWith(fresh);
        else if (wrap) wrap.remove();
        initReveal(this);
      } catch (e) {
        window.location.href = button.dataset.loadMore;
      }
    }
  }
  customElements.define('collection-filters', CollectionFilters);

  document.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-clear-filters]');
    if (!clear) return;
    const form = $('form[data-filter-form]');
    if (!form) return;
    event.preventDefault();
    $$('input', form).forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
      else if (input.type !== 'hidden') input.value = '';
    });
    form.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // While the hero buttons are on screen (mobile), the floating chat button would sit on top of them.
  const watchHeroActions = () => {
    const actions = $('.hero__actions');
    if (!actions || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => {
      document.documentElement.classList.toggle('hero-cta-on', entry.isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(actions);
  };

  const init = () => {
    initReveal();
    initFit();
    sortSizeOptions();
    watchHeroActions();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('cart:rendered', () => sortSizeOptions());
  document.addEventListener('shopify:section:load', (event) => {
    initReveal(event.target);
    initFit(event.target);
    sortSizeOptions(event.target);
  });
})();
